import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=66536cb2"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports